export default __webpack_public_path__ + "static/media/55_desktop.978263ba.jpg";